import { useRouter } from 'next/router';
import { ProfileUser } from 'lib/types/users';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import {
  userIsProfileOwner, userIsPaidTeamMember,
} from 'lib/helpers';
import { useUpgradeModal } from 'components/UpgradeModal';

interface Props {
  profileUser: ProfileUser;
}

export const JobsButton = ({
  profileUser,
}: Props) => {
  const currentUser = useCurrentUser();
  // const API = useApi();
  const router = useRouter();

  const { showUpgradeModal: showTeamUpgradeModal } = useUpgradeModal();

  const acceptApplication = async () => {
    if (!userIsPaidTeamMember(currentUser)) {
      showTeamUpgradeModal('Sign up for Teams to activate Work For Us on your profile');
      return;
    }
    // TODO: call API.toggleWorkForUs or similar with a teamId lookup
    router.push('/teams');
  };

  const getButton = () => {
    if (router.asPath.includes('/jobs')) {
      return (
        <button type="button" className="btn-primary" onClick={() => router.push(`/${profileUser.username}`)}>Profile</button>
      );
    }
    if (userIsProfileOwner(currentUser, profileUser)
      && !profileUser.teamAccount?.applicationsOpen) {
      return (
        <button type="button" className="btn-primary" onClick={acceptApplication}>Accept Applications</button>
      );
    }
    if (profileUser.teamAccount?.applicationsOpen || profileUser.teamAccount?.openJobs?.length) {
      return (
        <button type="button" className="btn-primary" onClick={() => router.push(`/${profileUser.username}/jobs`)}>Jobs</button>
      );
    }
    return null;
  };

  return (
    <>
      {getButton()}
    </>
  );
};
